import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.yield-files-new-page, .as-applied-files-new-page', () => {
  void import('./internal/yield-files-new-page__as-applied-files-new-page')
    .then(({ default: Component }) => Component());
});
